import { QuestionBase } from "./question-base";

export class NumberQuestion extends QuestionBase<number | string> {
  controlType = "number";
}
